import {LOAD_FOOTPRINT, RECEIVE_FOOTPRINT} from '../actions/Footprints';

const default_state = {
  footprints: {}
}

export const footprintReducer = (state = default_state, action) => {
  switch(action.type) {
    case LOAD_FOOTPRINT:
      state = Object.assign({}, state, {loading: true});
      break;
    case RECEIVE_FOOTPRINT:
      const footprints = { ...state.footprints, [action.name]: action.data};
      state = Object.assign({}, state, {loading: false, footprints: footprints});
      break;
    default:
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/Footprints.js